var resetPwdCtrl = function (restSvc, ifacsSvc, iFastWebContextRootSvc, $rootScope, $location, $cookies, $routeParams, loginLocation, $analytics, resetPasswordConstant) {
    "use strict";

    this.resetConstant = resetPasswordConstant;
    this[this.resetConstant.NEWPASSWORD] = undefined;
    this[this.resetConstant.CONFPASSWORD] = undefined;
    this.beforeLogin = true;

    this.restSvc = restSvc;
    this.ifacsSvc = ifacsSvc;
    this.iFastWebContextRootSvc = iFastWebContextRootSvc;
    this.rootScope = $rootScope;
    this.location = $location;
    this.cookies = $cookies;
    this.loginLocation = loginLocation;
    //this.token = $location.search().token;
    var url = this.location.absUrl();
    this.token = decodeURIComponent(url.substring(url.indexOf("token=") + 6, url.indexOf("#!/resetPwd")));
    this.analytics = $analytics;

    this.onLoad();
};

resetPwdCtrl.prototype.onLoad = function () {
    "use strict";
    var clientCd = this.iFastWebContextRootSvc.clientCode;
    this.isChangingPasswordSubmitted = false;
    this.onUsernamePwdChange();
    var rest = this.restSvc.query({type: "configuration", method: "retrieveChangePwdSetting"}, {"clientCd" : clientCd});
    rest.$promise.then(this.pass(this),this.fail);
};

resetPwdCtrl.prototype.pass = function (controller){
    "use strict";
    return function (result) {
        controller.userAdminSettingMap = result.userAdminSettingMap;
        controller.changePwdResponseMap = result.changePwdResponseMap;
    };

};

resetPwdCtrl.prototype.onSubmit = function () {
    "use strict";
    // track analytics
    this.analytics.eventTrack("ResetPassword",{"value":this.userAdminSettingMap.submit,"text":this.userAdminSettingMap.submit,"fieldName":"submit","objectName":"UserAdminSetting","submodule":"UserAdminSetting","module":"Prelogin"});

    this.ifacsSvc.resetPwd({ method:"change_pwd"},{
         "token":this.token,
         "new_password" : this[this.resetConstant.NEWPASSWORD],
         "conf_password" : this[this.resetConstant.CONFPASSWORD]
    }).$promise.then(this.passChangePwd(this));
};

resetPwdCtrl.prototype.passChangePwd = function (controller) {
    "use strict";

    window.console.log("Change password request is submitted.");

    return function(response) {
        var responseCode = response.code;
        window.console.log("Response from ifacs:" + responseCode);
        controller.isChangingPasswordSubmitted = true;
        controller.changePwdResponse = controller.changePwdResponseMap[responseCode];
        if ("SUCCESS" === responseCode) {
            controller.isResetPwdResponseOk = true;
            controller.disableSubmit = true;
            var redirectUrl = controller.userAdminSettingMap.changePwdRedirectUrl;
            window.console.log("redirectUrl=" + redirectUrl);
            if (redirectUrl) {
                redirectUrl = redirectUrl.trim();
                if (0 < redirectUrl.length) {
                	 controller.loginLocation.url(redirectUrl + (redirectUrl.indexOf("?")>-1?"&":"?") + "pcs=yes" );
                }
            }
        } else {
            controller.isResetPwdResponseOk = false;
            controller.disableSubmit = false;
        }
    };
};

resetPwdCtrl.prototype.onCancel = function () {
    "use strict";
    this.loginLocation.url("/login");
};

resetPwdCtrl.prototype.onUsernamePwdChange = function () {
    "use strict";

    if (undefined !== this[this.resetConstant.NEWPASSWORD] && null !== this[this.resetConstant.NEWPASSWORD] && 0 < this[this.resetConstant.NEWPASSWORD].length &&
        undefined !== this[this.resetConstant.NEWPASSWORD] && null !== this[this.resetConstant.CONFPASSWORD]  && 0 < this[this.resetConstant.CONFPASSWORD].length) {
        this.disableSubmit = false;
    } else {
        this.disableSubmit = true;
    }
};

resetPwdCtrl.$inject = ["restSvc", "ifacsSvc", "iFastWebContextRootSvc", "$rootScope", "$location", "$cookies", "$routeParams", "loginLocation", "$analytics", "resetPasswordConstant"];
angular.module("iFAST.login")
    .constant("resetPasswordConstant",{
        "NEWPASSWORD": "new_password",
        "CONFPASSWORD": "conf_password"
    })
    .controller("resetPwdCtrl", resetPwdCtrl);


// WEBPACK FOOTER //
// ./WebContent/src/login/resetPwd-controller.js